export const embedUrl = (id) =>
  `https://www.youtube.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`;

export const PLATFORM_LABELS = {
  youtube: "YOUTUBE",
  vimeo: "VIMEO",
  dailymotion: "DAILYMOTION",
  twitch: "TWITCH",
  twitch_clip: "TWITCH CLIP",
  streamable: "STREAMABLE",
  file: "VIDEO FILE",
};

export const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    return d
      .toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
      .toUpperCase();
  } catch {
    return "";
  }
};
